
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/puzzles/mistakes/practice",
      function () {
        return require("private-next-pages/puzzles/mistakes/practice/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/puzzles/mistakes/practice"])
      });
    }
  